import { FlatList as rFlatList } from 'react-native';
import { createThemedComponent } from '../css/create-themed-component';
export const FlatList = createThemedComponent(rFlatList);
//# sourceMappingURL=FlatList.js.map